import { Box, Text } from 'grommet';
import React from 'react';
import { snakeCase } from '../utils/string';
import { PositionFixedBox } from '../utils/styled';
import Button from './Button';
import FontAwesomeIcon from './FontAwesomeIcon';

const MobileStickyBottomContainer = ({
    children,
    secondaryButtonProps,
    primaryButtonProps,
    tertiaryButtonProps,
    secondaryButtonBasis,
    primaryButtonBasis
}) => {
    const hasButton = secondaryButtonProps || primaryButtonProps;
    const hasTwoButtons = secondaryButtonProps && primaryButtonProps;
    const PrimaryButtonComponent = primaryButtonProps && primaryButtonProps?.component ? primaryButtonProps?.component : Button;
    const SecondaryButtonComponent = secondaryButtonProps && secondaryButtonProps?.component ? secondaryButtonProps?.component : Button; // for Menu / drop button customization

    return (
        <PositionFixedBox
            additionalStyle="z-index: 20;"
            bottom="0"
            left="0"
            id="bottom-bar"
            width="100%"
            border={{side: 'top'}}
            background={"background-front"}
            elevation="large"
            pad={{vertical: 'medium', right: 'medium', left: 'small'}}>
            {!hasButton ?
                children :
                <Box gap="small">
                    {tertiaryButtonProps &&
                        <Button
                            event={{section: `mobile_sticky_cta_container`, element: 'tertiary_cta', description: snakeCase(tertiaryButtonProps?.label)}} 
                            secondary
                            onClick={tertiaryButtonProps?.onClick}
                            label={(
                                <Box direction='row' gap='medium' align="center" fill="horizontal" justify="center" pad="xsmall">
                                    {tertiaryButtonProps?.icon && (<FontAwesomeIcon SelectedIcon={tertiaryButtonProps?.icon} size="small" color="text-high-contrast"/>)}
                                    {tertiaryButtonProps?.label ? (<Text>{tertiaryButtonProps.label}</Text>) : ''}
                                </Box>
                            )}
                            {...(tertiaryButtonProps?.buttonProps ? tertiaryButtonProps.buttonProps : {})}
                        />
                    }
                    <Box direction='row' gap="small" justify='center' align="center">
                        {secondaryButtonProps && (<Box {...(hasTwoButtons ? {basis: secondaryButtonBasis || "1/2"} : { fill: 'horizontal' })}>
                            <SecondaryButtonComponent
                                event={{section: `mobile_sticky_cta_container`, element: 'secondary_cta', description: snakeCase(secondaryButtonProps?.label)}} 
                                secondary
                                onClick={secondaryButtonProps?.onClick}
                                label={(
                                    <Box direction='row' gap='medium' align="center" fill="horizontal" justify="center" pad="xsmall">
                                        {secondaryButtonProps?.icon && (<FontAwesomeIcon SelectedIcon={secondaryButtonProps?.icon} size="small" color="text-high-contrast"/>)}
                                        {secondaryButtonProps?.label ? (<Text>{secondaryButtonProps.label}</Text>) : ''}
                                    </Box>
                                )}
                                {...(secondaryButtonProps?.buttonProps ? secondaryButtonProps.buttonProps : {})}
                            />
                        </Box>)}
                        {primaryButtonProps && (<Box  {...(hasTwoButtons ? {basis: primaryButtonBasis || "1/2"} : { fill: 'horizontal' })}>
                            <PrimaryButtonComponent
                                event={{section: `mobile_sticky_cta_container`, element: 'primary_cta', description: snakeCase(primaryButtonProps?.label)}} 
                                primary
                                onClick={primaryButtonProps?.onClick}
                                label={(
                                    <Box direction='row' gap='medium' align="center" fill="horizontal" justify="center" pad="xsmall">
                                        {primaryButtonProps?.icon && (<FontAwesomeIcon SelectedIcon={primaryButtonProps?.icon} size="small" color="text-high-contrast"/>)}
                                        {primaryButtonProps?.label ? (<Text>{primaryButtonProps.label}</Text>) : ''}
                                    </Box>
                                )}
                                {...(primaryButtonProps?.buttonProps ? primaryButtonProps.buttonProps : {})}
                            />
                        </Box>)}
                    </Box>
                </Box>
            }
        </PositionFixedBox>
    )
};

export default MobileStickyBottomContainer;